var path = 'views/display/download.html';
var html = "<div class=\"fd-m-field fd-m-string\"> <div class=fd-m-defaultField-container ng-include=\"'views/display/default_field.html'\"></div> <div class=\"fd-m-field-input fd-m-field-download\">{{field.value}}</div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;